import React, { useEffect, useState } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { X, Play, Gift } from "lucide-react";

// Simulated Jixxeo Rewarded Ad — always skippable, never forced.
export function RewardAdDialog({ open, onClose, onComplete, label = "Rewarded Ad" }) {
  const [count, setCount] = useState(5);
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (!open) { setCount(5); setDone(false); return; }
    if (count <= 0) { setDone(true); return; }
    const t = setTimeout(() => setCount((c) => c - 1), 1000);
    return () => clearTimeout(t);
  }, [open, count]);

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose?.()}>
      <DialogContent className="glass border-white/10 max-w-sm p-0 overflow-hidden" data-testid="reward-ad-dialog">
        <div className="relative h-52 bg-gradient-to-br from-jixxeo-blue/30 via-black to-jixxeo-purple/30 flex flex-col items-center justify-center">
          <button onClick={onClose} className="absolute top-3 right-3 text-white/60 hover:text-white z-10" data-testid="ad-skip-btn">
            <X className="w-5 h-5" />
          </button>
          <span className="absolute top-3 left-3 text-[10px] font-bold uppercase tracking-widest text-white/50">Jixxeo Ad · {label}</span>
          <Gift className="w-16 h-16 text-jixxeo-gold pulse-glow" />
          <p className="mt-3 text-sm text-white/70">Optional ad — earn a bonus reward</p>
        </div>
        <div className="p-5">
          {!done ? (
            <div className="text-center">
              <p className="font-display text-4xl text-jixxeo-green">{count}</p>
              <p className="text-xs text-muted-foreground mt-1">Reward unlocks in {count}s — you can skip anytime</p>
              <Button variant="ghost" className="mt-3 rounded-full text-muted-foreground" onClick={onClose} data-testid="ad-skip-btn-2">
                Skip ad
              </Button>
            </div>
          ) : (
            <Button
              className="w-full rounded-full bg-jixxeo-green text-black font-bold hover:bg-jixxeo-greenDark neon-green"
              onClick={() => { onComplete?.(); }}
              data-testid="ad-claim-btn"
            >
              <Play className="w-4 h-4 mr-2" /> Claim Reward
            </Button>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
